module.exports = __webpack_public_path__ + "static/media/19-1.55efde0a.mp3";